import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type SectionLabelProps = {
	children: ReactNode;
	className?: string;
};

// Mono-uppercase page-orientation marker. Sits above a surface frame.
export function SectionLabel({ children, className }: SectionLabelProps) {
	return (
		<span
			className={cn(
				"font-mono text-[0.6875rem] tracking-[var(--tracking-mono)] uppercase text-muted",
				className,
			)}
		>
			{children}
		</span>
	);
}
